export default "__VITE_ASSET__ws6GX8$5__"